import { render, staticRenderFns } from "./LangSubmitDialog.vue?vue&type=template&id=62269b41&scoped=true&"
import script from "./LangSubmitDialog.vue?vue&type=script&lang=js&"
export * from "./LangSubmitDialog.vue?vue&type=script&lang=js&"
import style0 from "./LangSubmitDialog.vue?vue&type=style&index=0&id=62269b41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62269b41",
  null
  
)

export default component.exports